import React, { useEffect } from 'react';
import { useFramework } from '@/framework';
import { ILayerProps } from '@/version-types';
import DefaultShortcutList from '../components/shortcut/index';
import './shortcut.less';

const ShortcutMenu: React.FC = () => {
    const framework = useFramework();

    useEffect(() => {
        let activeLayerInfo: {
            layer: ILayerProps | null;
            pickLayer: ILayerProps | null;
        } = {
            layer: null,
            pickLayer: null,
        };
        let isNeedHide = false;
        // 隐藏菜单
        const handler = framework.operate.shortcutMenu.onHide((isHide) => {
            isNeedHide = isHide;
            showShortcutMenu();
        });
        // 图层数据变化
        const handler1 = framework.events.onActiveLayerDataUpdate((layer, pickLayer) => {
            activeLayerInfo = {
                layer,
                pickLayer,
            };
            showShortcutMenu();
        });
        // 自定义菜单变化
        const handler2 = framework.operate.shortcutMenu.onCustomMenu(() => {
            showShortcutMenu();
        });

        function showShortcutMenu() {
            const { layer } = activeLayerInfo;
            if (isNeedHide || !layer) {
                framework.operate.shortcutMenu.set(null);
            } else {
                framework.operate.shortcutMenu.set(<DefaultShortcutList id={layer.id} />);
            }
        }
        return () => {
            framework.events.off(handler);
            framework.events.off(handler1);
            framework.events.off(handler2);
        };
    }, []);

    return null;
};

export default React.memo(ShortcutMenu);
